import { render, staticRenderFns } from "./dui-context-menu.vue?vue&type=template&id=7ffe5631&scoped=true&"
import script from "./dui-context-menu.vue?vue&type=script&lang=js&"
export * from "./dui-context-menu.vue?vue&type=script&lang=js&"
import style0 from "./dui-context-menu.vue?vue&type=style&index=0&id=7ffe5631&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe5631",
  null
  
)

export default component.exports